.menuToggle {
    height: 100%;
    font: var(--font-button);

    & svg {
        width: 10px;
        height: 10px;
        margin-left: var(--spacer-8);
        fill: var(--color-contrast);
        transform: rotate(0deg);
        transition: transform 0.2s;
    }

    &.isOpen {
        & svg {
            transform: rotate(180deg);
        }

        + nav {
            display: block;
        }
    }

    + nav {
        display: none;
        position: absolute;
        left: 0;
        right: 0;
        padding-inline: var(--labui-container-margin);
        background-color: var(--black);

        ul {
            flex-direction: column;
            font: var(--font-button);
            gap: 0;

            li {
                padding: 0;

                a {
                    display: block;
                    padding: var(--spacer-24) 0;
                }

                &::after {
                    display: none;
                }
            }
        }
    }
}
